import scale from 'media/scale.svg'
import plate from 'media/plate.svg'
import clock from 'media/clock.svg'
import React, { useState } from 'react'
import AppButtons from '../AppButtons/AppButtons'
import convert from 'htmr'
import Overlay from 'js/components/Overlay/Overlay'

const recipes = [
  {
    image: require('media/recipes/cheesy-egg-clouds.jpg'),
    title: 'Cheesy Egg Clouds',
    description: 'Cheese and bacon make for the perfect keto breakfast dish.',
    kcal: 358,
    minutes: 30,
    netCarbs: 1.2,
    fat: 25,
    protein: 29,
    ingredientCount: 5,
    servings: 2,
    complexity: 'Medium',
    cholesterol: 515,
    sodium: 975,
    potassium: 178,
    ingredients: [
      '4 eggs',
      '2 tbsp parmesan, grated',
      '4 slices cooked bacon, crumbled',
      '1 tbsp chives, chopped',
      'Pepper',
    ],
    instructions: [
      'Preheat the oven to <b>400 °F (200 °C)</b>.',
      'Crack the <b>eggs</b>, placing all the egg whites in one bowl and separating the egg yolks in individual containers so they stay whole.',
      'Whip the <b>egg whites</b> untill stiff (so you can turn the bowl upside down without the batter flowing out). Lightly stir in the <b>parmesan</b>, <b>bacon</b> and <b>chives</b>.',
      'Line a baking tray. Create four "clouds" with the <b>egg mixture</b>. With a spoon, create a small wall with a pit in the middle of the egg cloud.',
      'Bake in the oven for <b>3 minutes</b>. Take them out and place one <b>yolk</b> in the middle of each. Season with <b>pepper</b> and bake for another <b>2-3 minutes</b>, until the yolks are almost set.',
    ],
  },
  {
    image: require('media/recipes/stuffed-avocado.jpg'),
    title: 'Tomato and Cilantro Stuffed Avocado',
    description: 'A comforting meat-free meal in under 30 minutes.',
    kcal: 342,
    minutes: 25,
    netCarbs: 1.7,
    fat: 35,
    protein: 3,
    ingredientCount: 4,
    servings: 2,
    complexity: 'Easy',
    cholesterol: 0,
    sodium: 9,
    potassium: 661,
    ingredients: [
      '2 avocados (9 oz / 240 g)',
      '1 ½ tbsp olive oil',
      '12 cherry tomatoes (2 oz / 60 g)',
      '1 tbsp cilantro / coriander, finely chopped',
    ],
    instructions: [
      'Preheat the oven to <b>400 °F (200 °C)</b>.',
      'Halve the <b>avocados</b>, and put the halves on a lined baking tray or in an oven-safe dish. Drizzle with half the <b>olive oil</b>. ',
      'Slice the <b>cherry tomatoes</b>. Put them in a bowl and toss together with the rest of the <b>olive oil</b> and <b>chopped cilantro</b>. Place the <b>tomatoes</b> in the pit where the core has been.',
      'Bake for <b>15 minutes</b>.',
    ],
  },
  {
    image: require('media/recipes/sesame-salmon.jpg'),
    title: 'Sesame Salmon with Fresh Veg Salad',
    description: 'A colorful, filling salad, great for both lunch and dinner.',
    kcal: 615,
    minutes: 20,
    netCarbs: 6.5,
    fat: 50,
    protein: 32,
    ingredientCount: 9,
    servings: 4,
    complexity: 'Easy',
    cholesterol: 0,
    sodium: 109,
    potassium: 697,
    ingredients: [
      '4 salmon fillets',
      '4 tbsp sesame seeds (black and white',
      '2 tbsp olive oil',
      '2 avocados, halved',
      '2/3 cup spinach leaves',
      '½ medium cucumber, with peel, sliced',
      '1 cup salad, any kind, chopped',
      '1 cup carrots, grated',
      '16 medium radishes, halved',
    ],
    instructions: [
      'Roll the <b>salmon fillets</b> in the <b>sesame seeds</b>. Fry in <b>olive oil</b>, <b>1 minute</b> per side.',
      'Arrange all the prepared <b>vegetables</b> on a plate, and top with the lukewarm <b>sesame salmon</b>, whole or sliced.',
    ],
  },
]

const RecipesTeaser = () => {
  const [recipeOverlayOpen, setRecipeOverlayOpen] = useState(false)
  const [ingredientsExpanded, setIngredientsExpanded] = useState(false)
  const [instructionsExpanded, setInstructionsExpanded] = useState(false)
  const [popoverRecipe, setPopoverRecipe] = useState<
    null | (typeof recipes)[0]
  >()

  const toggleRecipeOverlay = (i?) => {
    setRecipeOverlayOpen(!recipeOverlayOpen)
    setPopoverRecipe(typeof i !== 'undefined' ? recipes[i] : null)
  }

  const toggleIngredients = () => {
    setIngredientsExpanded(!ingredientsExpanded)
  }

  const toggleInstructions = () => {
    setInstructionsExpanded(!instructionsExpanded)
  }

  return (
    <>
      <div className="c-recipes-teaser">
        <div className="c-recipes-teaser__inner">
          {recipes.map((recipe, i) => {
            return (
              <div className="c-recipes-teaser__card" key={i}>
                <div className="c-recipes-teaser__recipe c-recipes-teaser__card-inner">
                  <button
                    className="c-recipes-teaser__button"
                    type="button"
                    onClick={() => {
                      toggleRecipeOverlay(i)
                    }}
                  >
                    <div className="c-recipes-teaser__image-wrapper">
                      <img
                        className="c-recipes-teaser__image"
                        src={recipe.image}
                        alt=""
                      />
                    </div>
                    <h3 className="c-recipes-teaser__recipe-title">
                      {recipe.title}
                    </h3>
                    <ul className="c-recipes_teaser__recipe-meta">
                      <li className="c-recipes_teaser__recipe-meta-item">
                        {recipe.kcal} kcal
                      </li>
                      <li className="c-recipes_teaser__recipe-meta-item">
                        {recipe.minutes} min
                      </li>
                    </ul>
                  </button>
                </div>
              </div>
            )
          })}
          <div className="c-recipes-teaser__card">
            <div className="c-recipes-teaser__card-inner">
              <h3 className="c-recipes-teaser__cta-heading">
                See all keto recipes in the Lifesum app!
              </h3>
              <AppButtons onlyOne={true} centered={true} />
              <div className="c-recipes-teaser__cta-rating  c-review">
                <div className="c-review__rating  c-review__rating--4-5" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {recipeOverlayOpen && popoverRecipe && (
          <Overlay onOutsideClick={toggleRecipeOverlay}>
            <div className="c-recipes-teaser__popover">
              <button
                className="c-recipes-teaser__popover-close"
                onClick={toggleRecipeOverlay}
              >
                Close
              </button>
              <div className="c-recipes-teaser__popover-inner">
                <div className="c-recipes-teaser__popover-image-wrapper">
                  <img
                    className="c-recipes-teaser__popover-image"
                    src={popoverRecipe.image}
                    alt=""
                  />
                </div>
                <h3 className="c-recipes-teaser__popover-heading">
                  {popoverRecipe.title}
                </h3>
                <ul className="c-recipes-teaser__popover-macros">
                  <li className="c-recipes-teaser__popover-macro">
                    {popoverRecipe.netCarbs}g net carbs
                  </li>
                  <li className="c-recipes-teaser__popover-macro">
                    {popoverRecipe.fat}g fat
                  </li>
                  <li className="c-recipes-teaser__popover-macro">
                    {popoverRecipe.protein}g protein
                  </li>
                </ul>
                <div className="c-recipe-facts c-recipe-facts--on-white">
                  <ul className="c-recipe-facts__list">
                    <li className="c-recipe-facts__item">
                      <div className="c-recipe-facts__symbol-wrapper">
                        <img
                          className="c-recipe-facts__symbol c-recipe-facts__symbol--clock"
                          src={clock}
                          alt=""
                        />
                      </div>
                      <span className="c-recipe-facts__text">
                        {popoverRecipe.minutes} min
                      </span>
                    </li>
                    <li className="c-recipe-facts__item">
                      <div className="c-recipe-facts__symbol-wrapper">
                        <img
                          className="c-recipe-facts__symbol c-recipe-facts__symbol--plate"
                          src={plate}
                          alt=""
                        />
                      </div>
                      <span className="c-recipe-facts__text">
                        {popoverRecipe.servings} servings
                      </span>
                    </li>
                    <li className="c-recipe-facts__item">
                      <div className="c-recipe-facts__symbol-wrapper">
                        <img
                          className="c-recipe-facts__symbol c-recipe-facts__symbol--scale"
                          src={scale}
                          alt=""
                        />
                      </div>
                      <span className="c-recipe-facts__text">
                        {popoverRecipe.kcal} kcal
                      </span>
                    </li>
                  </ul>
                </div>
                <p>{popoverRecipe.description}</p>
                <div
                  className={`c-recipes-teaser__popover-height-toggle${
                    ingredientsExpanded
                      ? ''
                      : ' c-recipes-teaser__popover-height-toggle--closed'
                  }`}
                >
                  <button
                    className="c-recipes-teaser__popover-height-toggle-button"
                    onClick={toggleIngredients}
                  >
                    Toggle ingredients
                  </button>
                  <h4 className="c-recipes-teaser__popover-sub-heading">
                    Ingredients
                  </h4>
                  <ul className="s-text">
                    {popoverRecipe.ingredients.map((ingredient, i) => {
                      return <li key={i}>{ingredient}</li>
                    })}
                  </ul>
                </div>
                <div
                  className={`c-recipes-teaser__popover-height-toggle${
                    instructionsExpanded
                      ? ''
                      : ' c-recipes-teaser__popover-height-toggle--closed'
                  }`}
                >
                  <button
                    className="c-recipes-teaser__popover-height-toggle-button"
                    onClick={toggleInstructions}
                  >
                    Toggle instructions
                  </button>
                  <h4 className="c-recipes-teaser__popover-sub-heading">
                    Instructions
                  </h4>
                  <ol className="c-recipes-teaser__popover-instructions">
                    {popoverRecipe &&
                      popoverRecipe.instructions.map((instruction, i) => (
                        <li
                          className="c-recipes-teaser__popover-instruction"
                          key={i}
                        >
                          {convert(instruction)}
                        </li>
                      ))}
                  </ol>
                </div>
                <h4 className="c-recipes-teaser__popover-sub-heading">
                  Nutrition information
                </h4>
                <p className="c-recipes-teaser__popover-serving">1 serving</p>
                <dl className="c-recipes-teaser__popover-info">
                  <dd>Calories</dd>
                  <dt>{popoverRecipe.kcal} kcal</dt>

                  <dd>Net carbs</dd>
                  <dt>{popoverRecipe.netCarbs} g</dt>

                  <dd>Fat</dd>
                  <dt>{popoverRecipe.fat} g</dt>

                  <dd>Protein</dd>
                  <dt>{popoverRecipe.protein} g</dt>

                  <dd>Cholesterol</dd>
                  <dt>{popoverRecipe.cholesterol} mg</dt>

                  <dd>Sodium</dd>
                  <dt>{popoverRecipe.sodium} mg</dt>

                  <dd>Potassium</dd>
                  <dt>{popoverRecipe.potassium} mg</dt>
                </dl>
              </div>
            </div>
          </Overlay>
        )}
      </div>
    </>
  )
}

export default RecipesTeaser
